// ScrollToTop.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 라우터 주소가 바뀔 때마다 실행
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto", // "smooth"로 하면 부드럽게 올라감
    });
  }, [pathname]);

  return null; // 화면에 아무것도 안 그리는 컴포넌트
}
